import React, { FC, ReactNode } from "react"
import { Box } from "@carrotfertility/carotene-core"

type WrapperProps = {
  small?: boolean
  smallMedium?: boolean
  medium?: boolean
  mediumLarge?: boolean
  children: ReactNode
}

const Wrapper: FC<WrapperProps> = (props) => {
  const maxInlineSize = props.small
    ? "32rem"
    : props.smallMedium
    ? "40rem"
    : props.medium
    ? "48rem"
    : props.mediumLarge
    ? "56rem"
    : "80rem"
  return (
    <Box
      sx={(theme) => ({
        inlineSize: "100%",
        marginInline: "auto",
        maxInlineSize: "80rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingInline: theme.spacing(theme.tokens.spacing.md),
        paddingBlock: { xs: 0, md: theme.spacing(theme.tokens.spacing.md) }
      })}
    >
      <Box
        sx={(theme) => ({
          inlineSize: "100%",
          maxInlineSize,
          paddingBlock: { xs: theme.spacing(theme.tokens.spacing.xs), md: theme.spacing(theme.tokens.spacing.md) },
          paddingInline: { xs: 0, md: theme.spacing(theme.tokens.spacing.md) }
        })}
      >
        {props.children}
      </Box>
    </Box>
  )
}

export default Wrapper
